import { Button, Collapse, Kbd, Stack } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";

const getOS = (ua: string): string => {
  if (/Windows NT 10/i.test(ua))      return "Windows 10";
  if (/Windows NT 6\.3/i.test(ua))   return "Windows 8.1";
  if (/Windows NT 6\.1/i.test(ua))   return "Windows 7";
  if (/Mac OS X 10[._]\d+/i.test(ua)) {
    const ver = ua.match(/Mac OS X (10[._]\d+)/i)![1].replace("_", ".");
    return `macOS ${ver}`;
  }
  if (/Android (\d+(\.\d+)?)/i.test(ua)) {
    const ver = ua.match(/Android (\d+(\.\d+)?)/i)![1];
    return `Android ${ver}`;
  }
  if (/iPhone OS (\d+(_\d+)?)/i.test(ua)) {
    const ver = ua.match(/iPhone OS (\d+(_\d+)?)/i)![1].replace("_", ".");
    return `iOS ${ver}`;
  }
  return "Unknown OS";
};

const getBrowser = (ua: string): string => {
  if (/Edg\/(\d+)/i.test(ua)) {
    const v = ua.match(/Edg\/(\d+)/i)![1];
    return `Edge ${v}`;
  }
  if (/OPR\/(\d+)/i.test(ua)) {
    const v = ua.match(/OPR\/(\d+)/i)![1];
    return `Opera ${v}`;
  }
  if (/Chrome\/(\d+)/i.test(ua) && !/Edg\//i.test(ua)) {
    const v = ua.match(/Chrome\/(\d+)/i)![1];
    return `Chrome ${v}`;
  }
  if (/Firefox\/(\d+)/i.test(ua)) {
    const v = ua.match(/Firefox\/(\d+)/i)![1];
    return `Firefox ${v}`;
  }
  if (/Version\/(\d+(\.\d+)?) Safari\//i.test(ua)) {
    const v = ua.match(/Version\/(\d+(\.\d+)?)/i)![1];
    return `Safari ${v}`;
  }
  return "Unknown Browser";
};

const DeviceInfo: React.FC = () => {
  const [deviceModel, setDeviceModel] = useState("Detecting…");
  const [show, setShow] = useState(false);

  useEffect(() => {
    const runChecks = async () => {
      let model: string | undefined;

      // 1) Client Hints
      // @ts-ignore
      if (navigator.userAgentData?.getHighEntropyValues) {
        try {
          // @ts-ignore
          const hints = await navigator.userAgentData.getHighEntropyValues(["model"]);
          if (hints.model) model = hints.model;
        } catch { /* ignore */ }
      }

      // 2) Fallback UA parsing
      if (!model) {
        const ua = navigator.userAgent;
        const os = getOS(ua);
        const browser = getBrowser(ua);
        model = `${os} — ${browser}`;
      }

      setDeviceModel(model);
    };

    runChecks();
  }, []);

  return (
    <Stack>
      <Button onClick={() => setShow(s => !s)}>{show ? "Hide" : "Show"} Device Info</Button>

      <Stack alignItems={'center'}>
        <Collapse in={show} animateOpacity>
          <Kbd>{deviceModel}</Kbd>
        </Collapse>
      </Stack>
    
    </Stack>
    // <div style={{ padding: 16 }}>
    //   <button onClick={() => setShow(s => !s)}>
    //     {show ? "Hide" : "Show"} Device Info
    //   </button>
    //   {show && <p>Your device: <strong>{deviceModel}</strong></p>}
    // </div>
  );
};

export default DeviceInfo;
